import { API_URL } from './constants';
import {
  SendWeeklyReportRequestDto,
  SendWeeklyReportResponseDto,
} from './types/analytics';

export async function apiAnalyticsTestWeeklyReport(
  token: string,
  body: SendWeeklyReportRequestDto,
): Promise<[SendWeeklyReportResponseDto, number]> {
  const url = new URL(`${API_URL}/admin/analytics/send-weekly-report`).href;
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });
  return [
    (await response.json()) as SendWeeklyReportResponseDto,
    response.status,
  ];
}
